import { render, staticRenderFns } from "./DataTableRowHandler.vue?vue&type=template&id=5f813498&scoped=true&"
import script from "./DataTableRowHandler.vue?vue&type=script&lang=js&"
export * from "./DataTableRowHandler.vue?vue&type=script&lang=js&"
import style0 from "./DataTableRowHandler.vue?vue&type=style&index=0&id=5f813498&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f813498",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
